import { Radio, type RadioProps } from '@/components/controls';

export const FormRadio = (props: RadioProps) => {
  return <Radio {...props} />;
};

FormRadio.displayName = 'Form.Radio';
